import styled from 'styled-components'

export const HomePageWrapper = styled.div`
  width: 100%;
  .home {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
  }
  @media (max-width: 1000px) {
    display: block;
  }
`

export const LeftHomePageComponent = styled.div`
  width: 100%;
`
// export const RightHomePageComponent = styled.div`
//   flex: 0%;
//   margin-top: 3.2rem;
//   margin-left: 15px;

//   .call_to_action_btn {
//     display: flex;
//     justify-content: flex-end;
//     @media (max-width: 1000px) {
//       display: none;
//     }
//   }
//   @media (max-width: 1000px) {
//     margin-top: 0rem;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//   }
// `

export const CallToActionCard = styled.div`
  background: ${({ theme }) => theme.colors.white};
  margin-top: 2.3rem;
  width: auto;
  height: auto;
  border-radius: 0 0 10px 10px;
  border: 2px solid #f8f8f8;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    display: none;
  }
  .image {
    height: 160px;
    width: 361px;
    object-fit: cover;
    object-position: center;
    border-radius: 10px 10px 0px 0px;
  }
  .user_img {
    display: flex;
    align-items: center;
    margin-top: 5px;
    .string {
      margin-left: 2px;
    }
  }
  .card_body {
    padding: 0 16px;

    .call_to_action_link {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #6979f8;
      display: flex;
      align-items: center;
      margin-bottom: 25px;
      margin-top: 5px;

      span {
        padding-left: 10px;
        padding-top: 8px;
      }
    }
  }

  .header_img img {
    width: 100%;
  }

  .title_user {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: ${({ theme }) => theme.colors.black};
  }
  .card_text_link {
    margin-top: -8px;
    width: 269px;
    p {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #4f4f4f;
      margin-top: -15px;
      mix-blend-mode: normal;
    }
  }
`

export const CallToActionHomeCard = styled.div`
  background: ${({ theme }) => theme.colors.white};
  margin-top: 2.3rem;
  width: 33%;
  height: auto;
  border: 2px solid #f8f8f8;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    display: none;
  }
  .image {
    height: 160px;
    width: 361px;
    object-fit: cover;
    object-position: center;
    border-radius: 10px 10px 0px 0px;
  }
  .user_img {
    display: flex;
    align-items: center;
    margin-top: 5px;
    .string {
      margin-left: 2px;
    }
  }
  .card_body {
    padding: 0 16px;

    .call_to_action_link {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #6979f8;
      display: flex;
      align-items: center;
      margin-bottom: 25px;
      margin-top: 5px;

      span {
        padding-left: 10px;
        padding-top: 8px;
      }
    }
  }

  .header_img img {
    width: 100%;
  }

  .title_user {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    margin-top: 10px;
    color: ${({ theme }) => theme.colors.black};
  }
  .card_text_link {
    margin-top: -8px;
    width: 269px;

    p {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #4f4f4f;
      margin-top: -15px;
      mix-blend-mode: normal;
    }
  }
`
